import { createSlotRecipe } from './runtime';

const popoverConfig = {"name":"popover","slots":["arrow","arrowTip","anchor","trigger","indicator","positioner","content","title","description","closeTrigger"]}

export const popover = /* @__PURE__ */ createSlotRecipe(popoverConfig)